import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlesSection() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-16">
          <p className="text-xs tracking-[0.25em] uppercase text-foreground-500 mb-3 font-label">Learn & Grow</p>
          <h2 className="font-heading text-5xl md:text-6xl font-bold text-foreground-950">
            Sourcing Guides
          </h2>
          <p className="mt-4 text-foreground-600 text-lg max-w-[560px]">
            In-depth articles to help you master the itaobuy sheet and build a profitable sourcing workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group block rounded-2xl border border-background-200/70 overflow-hidden bg-background-50 hover:border-foreground-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] bg-background-100 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-background-50/90 text-[11px] font-medium text-foreground-700 whitespace-nowrap">
                    {article.readTime}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Read Article
                  <i className="ri-arrow-right-s-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}